import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import star from '@assets/icons/star.svg';
import messages from '../../messages';

const NoReviewsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  text-align: center;
  position: fixed;
  top: 50%;
  width: 100%;
  height: 100%;
  left: 50%;
  transform: translate(-50%, -50%);

  h3 {
    font-size: 24px;
    font-weight: 800;
    padding: 0 8%;
  }

  span {
    padding: 0 8%;
  }
`;

const StarImage = styled.img``;

function NoReviews() {
  return (
    <NoReviewsContainer>
      <StarImage src={star} alt="El comercio no tiene opiniones" />
      <FormattedMessage {...messages.noReviewsTitle}>
        {title => <h3>{title}</h3>}
      </FormattedMessage>
      <FormattedMessage {...messages.noReviewsSubtitle}>
        {subtitle => <span>{subtitle}</span>}
      </FormattedMessage>
    </NoReviewsContainer>
  );
}

export default NoReviews;
